import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import default_user from '../assets/images/default_user.webp';
import default_header_image from '../assets/images/default_header_image.png';
import white_drop_icon from '../assets/images/whitedrop_down.svg';
import verified from '../assets/images/verified.svg';
import config from '../config/config';
import CollectionUserDropdownRestricted from './CollectionUserDropdownRestricted';
import RestrictedCreateList from './RestrictedCreateList';
import RestrictedUserList from './RestrictedUserList';
import TipButtonCollection from './TipButtonCollection';
import { PaystackButton } from 'react-paystack';
import PropTypes from 'prop-types'; 

const UserCardRestricted = ({ user, user_name, walletBalance }) => {
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [toastMessage, setToastMessage] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false); 
  const [errorMessage, setErrorMessage] = useState('');
  const [reason, setReason] = useState('');
  const [subscriptions, setSubscriptions] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [loading, setLoading] = useState(true);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [toastType, setToastType] = useState('');
  const [userData, setUserData] = useState({
    user_id: '',
    name: '',
    user_name: '',
    email: '',
    subs_type: '',
    is_subscribed: false,
    subscription_details: null,
  });
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };

const handleCopyLink = (userName) => {
  const profileUrl = `${window.location.origin}/${userName}`;
  navigator.clipboard.writeText(profileUrl)
    .then(() => {
      setToastMessage('Profile link copied to clipboard!');
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    })
    .catch(() => {
      setErrorMessage('Error copying link');
    });
};

const subscriptionPlanId = user.subscription_plan_id;

const handleSubscribe = async (paymentMethod = '', transactionId = '') => {
  // Initialize requestData with required fields
  const requestData = {
    subscribe_to_user_id: user.id,
    user_plan_id: subscriptionPlanId,  // Use subscription_plan_id
    payment_method: paymentMethod,
  };

  // Only add transaction_id if payment method is not 'userwallet'
  if (paymentMethod !== 'userwallet') {
    requestData.transaction_id = transactionId; // Only include transactionId for non-wallet payments
  }

  // Check if payment method is 'userwallet'
  if (paymentMethod === 'userwallet') {
    const walletBalance = userData.wallet_balance;
    const planAmount = user.amount;

    // Ensure wallet balance is sufficient
    if (walletBalance < planAmount) {
      showToast('Insufficient wallet balance for this subscription.', 'error');
      return; // Exit function if insufficient balance
    }
  }

  try {
    const response = await axios.post(`${config.baseURL}/subscribe-user`, requestData, { headers });

    if (response.data.success) {
      setToastMessage(response.data.message || 'Subscription successful!'); // Set success message
      setToastType('success');
      setShowToast(true); // Show success toast
      window.location.reload();
    } else {
      setToastMessage(response.data.message || 'Subscription failed'); // Set error message
      setToastType('error');
      setShowToast(true); // Show error toast
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Error subscribing user';
    setToastMessage(errorMessage); // Set error message
    setToastType('error');
    setShowToast(true); // Show error toast
  }
};


const unsubscriptionPlanId = user.subscription_id;

const handleUnsubscribe = async () => {
  const requestData = {
    subscription_id: unsubscriptionPlanId, // Change to subscription_id
    unsubscribe_reason: reason || '', // Pass reason if available, or an empty string
  };

  try {
    const response = await axios.post(`${config.baseURL}/unsubscribe-user`, requestData, { headers });

    if (response.data.success) {
      setToastMessage(response.data.message || 'Unsubscription successful!'); // Set success message
      setToastType('success');
      setShowToast(true); // Show toast
      setShowUnsubscribeModal(false); // Close modal if successful
    } else {
      setErrorMessage(response.data.message || 'Unsubscription failed'); // Set error message
      setToastType('error');
      setShowToast(true); // Show toast
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Error unsubscribing user';
    setErrorMessage(errorMessage); // Set error message
    setToastType('error');
    setShowToast(true); // Show toast
  }
};


 const OpenPaymentModel  =() => {
    document.body.classList.add('collection_unsubscribe');
    setShowPaymentModal(true);
 }

  const handleOpenUnsubscribeModal = () => {
    document.body.classList.add('collection_unsubscribe');
    setShowUnsubscribeModal(true);
  };

  const handleCloseModal = () => {
    document.body.classList.remove('collection_unsubscribe');
    setShowUnsubscribeModal(false);
    setShowPaymentModal(false);
  };


  const getInitials = (name) => {
    const nameParts = name.split(' ');
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
  };

const onSuccess = (reference) => {
  handleSubscribe('paystack', reference.reference);  // Use the subscription_plan_id from the state or variable
  setShowPaymentModal(false);
};


  const onClose = () => {
    console.log('Payment window closed');
  };  

const handleNowPayments = async () => {
  const requestData = {
    price_amount: user.amount,
    price_currency: "usd",
    pay_currency: "btc",
    ipn_callback_url: "https://yourwebsite.com/callback",
  };

  try {
    const response = await axios.post('https://api-sandbox.nowpayments.io/v1/payment', requestData, {
      headers: {
        'x-api-key': '11H5KAD-1NC4A54-NG25HG0-Y78N8BS',
        'Content-Type': 'application/json'
      }
    });

    if (response.data?.payment_url) {
      window.open(response.data.payment_url, '_blank');
      handleSubscribe('nowpayments');  // Use the subscription_plan_id from the state or variable
    } else {
      setErrorMessage('Failed to initiate NowPayments transaction.');
      setShowToast(true);
    }
  } catch (error) {
    setErrorMessage(error.response?.data?.message || 'Error initiating NowPayments transaction');
    setShowToast(true);
  }
};

const paystackConfig = {
    reference: (new Date()).getTime().toString(),
    email: user.email,
    // amount: user.amount ? user.amount * 100 : (selectedSubscription ? selectedSubscription.plan_amount * 100 : 0),
    amount: user.amount ? user.amount * 100 : (user.plan_amount ? user.plan_amount * 100 : 0),
    publicKey: 'pk_test_6d954b11ef91c1d7a8911f46a866de5f37a5771a', // Replace with your public key
    onSuccess,
    onClose,
};


  return (
    <>
    <div className="col-md-6">
      <div className="profile_model_card_collections">
        <div className="profile_model_card_collections_inner">
          <Link className="cover_card" to={`/${user.username}`}>
            <div className="card_item__cover__wrapper">
              <img src={user.back_profile || default_header_image} alt="Cover" />
            </div>
          </Link>
          <div className="card_item_group_card more_options">
            <div className="share_btn">
              <Link onClick={() => handleCopyLink(user.username)}>
                <svg className="icon_dropdown share_post_icon" width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.9991 36C18.3325 28 22.7974 13.8002 45.9974 15.0002" stroke="#ffffff" strokeWidth="4.2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M39 5L49 15L39 25" stroke="#ffffff" strokeWidth="4.66667" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M21.5556 7H16.6667C12.933 7 11.0661 7 9.64006 7.76295C8.38565 8.43407 7.36578 9.50493 6.72662 10.8221C6 12.3194 6 14.2796 6 18.2V37.8C6 41.7204 6 43.6806 6.72662 45.1779C7.36578 46.4951 8.38565 47.5659 9.64006 48.237C11.0661 49 12.933 49 16.6667 49H35.3333C39.067 49 40.9339 49 42.3599 48.237C43.6144 47.5659 44.6342 46.4951 45.2734 45.1779C46 43.6806 46 41.7204 46 37.8V32.6667" stroke="#ffffff" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Link>
            </div>            
            <CollectionUserDropdownRestricted user={user} userId={user.user_id} />
          </div>
          <div className="user_details_card">
            <Link to={`/${user.username}`}>
              <div className={`img_avatar_card ${user.online_status === 'online' ? 'user_online_status' : ''}`}>
                {user.profile ? (
                  <img src={user.profile} alt="Avatar" />
                ) : (
                  <span className="profile_name_none_image">{getInitials(user.name)}</span>
                )}
              </div>
            </Link>
            <div className="card_user_info_box">
              <div className="card-b-profile-status"> {user.online_status} </div>
              <div className="card-b-names">
                <div className="b-card_name">
                  <Link to={`/${user.username}`}> {user.name} {user.subs_mode === 'paid' && <img className="card_verify_icon" src={verified} alt="Verified" />} </Link>
                </div>
                <div className="b-card_name_user">
                  <Link to={`/${user.username}`}> @{user.username} </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="card_all_info_data">
              {user.is_in_list === true ? (
                <RestrictedUserList user={user.username} userId={user.id} UserlistId={user.list_id} UserlistName={user.list_name} />
              ) : (
                <RestrictedCreateList user={user.username} userId={user.id} />
              )} 

              <div className="card_btn_collection">
              {user.user_role === 'creator' ? (
              user.subscription_status === 'active' ? (
                  <button 
                    onClick={handleOpenUnsubscribeModal} // Opens Unsubscribe Modal for active subscriptions
                    className={`subscription_btn ${user.subs_mode === 'paid' ? 'paid' : 'subscribed'}`}
                  >
                    {user.subs_mode === 'free' ? (
                      <>
                        <span>Subscribed</span>
                        <span>for free</span>
                      </>
                    ) : (
                      <ul className="button_plan_list">
                        {user.subs_mode === 'paid' && (
                          <li>
                            <span>Subscribed</span> 
                            <span>{user.amount ? `$${user.amount}` : 'Subscription amount details unavailable'}</span>
                          </li>
                        )}
                      </ul>
                    )}
                  </button>
                ) : (
                  <button 
                    onClick={() => {
                      if (user.subs_mode === 'free') {
                        handleSubscribe(); // Directly subscribe for free without payment modal
                      } else {
                        OpenPaymentModel(); // Open payment modal for paid subscriptions
                      }
                    }} 
                    className="subscription_btn payment"
                  >
                    {user.subs_mode === 'free' ? (
                      <>
                        <span>Subscribe</span>
                        <span>for free</span>
                      </>
                    ) : (
                      <>
                        <span>Subscribe</span>
                        <span>${user.amount || user.plan_amount || 'N/A'}</span>

                      </>
                    )}
                  </button>
                )
              ) : null } {/* Return nothing if not 'creator' */}
            </div>
            </div>
        </div>
      </div>
    </div>
    <div className={`modal-overlay ${showUnsubscribeModal ? 'show' : ''}`} onClick={handleCloseModal} />
      <div className={`modal restoreAccessModalAccess fade ${showUnsubscribeModal ? 'show' : ''}`} tabIndex="-1" aria-labelledby="restoreAccessModalLabel" aria-hidden="true" style={{ display: showUnsubscribeModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="restoreAccessModalLabel">Unsubscribe</h5>
              <button type="button" className="btn-close" onClick={handleCloseModal} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to cancel your subscription?</p>
              <select className="form-control" value={reason} onChange={(e) => setReason(e.target.value)}>
                  <option value="No specific reason">No specific reason</option>
                  <option value="Low posting frequency">Low posting frequency</option>
                  <option value="Private messages not replied">Private messages not replied</option>
                  <option value="No longer want to be subscribed">No longer want to be subscribed</option>
              </select>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary send_btn" onClick={handleCloseModal}>Close</button>
              <button type="button" className="btn btn-primary send_btn" onClick={handleUnsubscribe}>Unsubscribe</button>
            </div>
          </div>
        </div>
    </div>
  <div className={`modal-overlay ${showPaymentModal ? 'show' : ''}`} onClick={handleCloseModal} />
      <div className={`modal paymentModal fade ${showPaymentModal ? 'show' : ''}`} tabIndex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true" style={{ display: showPaymentModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="paymentModalLabel">Choose Payment Method</h5>
              <button type="button" className="btn-close" onClick={handleCloseModal} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>Select your preferred payment method to proceed with the subscription.</p>
              <select className="form-select" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                <option value="">Select Payment Method</option>
                <option value="paystack">Paystack</option>
                <option value="nowpayments">NowPayments</option>
                {walletBalance > 0 && (
                    <option value="userwallet">Wallet Balance (${walletBalance})</option>
                  )} {/* Only render if walletBalance is greater than 0 */}
              </select>
            </div>

            <div className="modal-footer">
              {paymentMethod === 'paystack' && (
                <PaystackButton className="btn btn-primary send_btn" {...paystackConfig}> 
                  Pay Now
                </PaystackButton>
              )}
              {paymentMethod === 'nowpayments' && (
                <button type="button" className="btn btn-primary send_btn" onClick={handleNowPayments}>
                  Pay Now
                </button>
              )}
              {paymentMethod === 'userwallet' && (
                <button
                  type="button"
                  className="btn btn-primary send_btn"
                  onClick={() => handleSubscribe(paymentMethod, 'userwallet')}
                >
                  Pay with Wallet
                </button>

              )}
            </div>
            
          </div>
        </div>
   </div>

  <div className="share_text">
        {/* Conditionally render error message */}
        {errorMessage && (
          <div className="error_message">{errorMessage}</div>
        )}
        {/* Conditionally render toast message */}
        {toastMessage && (
          <div className="toast_message">
            {toastMessage}
          </div>
        )}
      </div>
  </>
  );
};
UserCardRestricted.propTypes = {
    user: PropTypes.shape({
        user_id: PropTypes.string.isRequired,
        username: PropTypes.string.isRequired,
        profile: PropTypes.string,
        back_profile: PropTypes.string,
        online_status: PropTypes.string,
        name: PropTypes.string,
        subs_mode: PropTypes.string,
        user_role: PropTypes.string.isRequired,
        // Add other user properties as necessary
    }).isRequired,
};

export default UserCardRestricted;
